<i18n>
{
  "zh": {
    "openfile": "打开",
    "newfile": "新建",
    "newfileFromHome": "从模板创建",
    "savefile": "保存",
    "saveAs": "另存为",
    "renamefile": "重命名",
    "encryptfile": "文档加密",
    "importMenu": "导入",
    "importData": "导入数据",
    "downloadAs": "导出",
    "exportData": "导出数据",
    "share": "分享",
    "downloadFile": "下载",
    "print": "打印",
    "pageSet": "页面设置",
    "userLike": "默认设置",
    "toHome": "回到首页",
    "set": "收藏",
    "cancel": "取消收藏"
  },
  "en": {
    "openfile": "Open",
    "newfile": "New",
    "newfileFromHome": "Create from Template",
    "savefile": "Save",
    "saveAs": "Save As",
    "renamefile": "Rename",
    "encryptfile": "Encrypt",
    "importMenu": "Import",
    "importData": "Import Data",
    "downloadAs": "Export",
    "exportData": "Export Data",
    "share": "Share",
    "downloadFile": "Download",
    "print": "Print",
    "pageSet": "Page Setup",
    "userLike": "Default Setting",
    "toHome": "Home",
    "set": "Star",
    "cancel": "Unstar",
    "none": "No"
  },
  "fr": {
    "openfile": "Ouvert",
    "newfile": "Nouveau",
    "newfileFromHome": "Créer à partir d'un modèle",
    "savefile": "Sauvegarder ",
    "saveAs": "Sauvegarder comme",
    "renamefile": "Renommer",
    "encryptfile": "Crypter",
    "importMenu": "Importer",
    "importData": "Importer des données",
    "downloadAs": "Télécharger en tant que",
    "exportData": "Exporter des données",
    "share": "Partager",
    "downloadFile": "Télécharger",
    "print": "Imprimer",
    "pageSet": "Mise en page",
    "userLike": "Paramètres par défaut",
    "toHome": "Retour à l'accueil",
    "set": "Mise en place étoile",
    "cancel": "Annuler étoile",
    "none": "Rien"
  },
  "de": {
    "openfile": "Öffnen",
    "newfile": "Neu",
    "newfileFromHome": "Aus Vorlage erstellen",
    "savefile": "Speichern",
    "saveAs": "Speichern als",
    "renamefile": "Neu benennen",
    "encryptfile": "Verschlüsseln",
    "importMenu": "Importieren",
    "importData": "Daten importieren",
    "downloadAs": "Herunterladen als",
    "exportData": "Daten exportieren",
    "share": "Teilen ",
    "downloadFile": "Datei herunterladen",
    "print": "Drucken",
    "pageSet": "Seite einrichten",
    "userLike": "Voreinstellung",
    "toHome": "Home",
    "set": "Einstellen Sternen",
    "cancel": "Abbrechen Sternen",
    "none": "Nichts"
  },
  "jp": {
    "openfile": "開く",
    "newfile": "新規作成",
    "newfileFromHome": "テンプレートから新規作成",
    "savefile": "保存",
    "saveAs": "名前をつけて保存",
    "renamefile": "名前を変更",
    "encryptfile": "ファイルの暗号化",
    "importMenu": "インポート",
    "importData": "データのインポート",
    "downloadAs": "エクスポート",
    "exportData": "データをエクスポート",
    "share": "共有",
    "downloadFile": "ダウンロード",
    "print": "印刷",
    "pageSet": "ページ設定",
    "userLike": "初期設定",
    "toHome": "ホームに戻る",
    "set": "スターを追加",
    "cancel": "スターを外す",
    "none": "なし"
  },
  "es": {
    "openfile": "Abrir",
    "newfile": "Nuevo",
    "newfileFromHome": "Crear a partir de la plantilla",
    "savefile": "Guardar",
    "saveAs": "Guardar como",
    "renamefile": "Renombrar",
    "encryptfile": "Cifrar",
    "importMenu": "Importación",
    "importData": "Importar datos",
    "downloadAs": "Exportar",
    "exportData": "Exportar datos",
    "share": "Compartir",
    "downloadFile": "Descargar",
    "print": "Imprimir",
    "pageSet": "Configuración de la página",
    "userLike": "Configuración predeterminada",
    "toHome": "Ir a Inicio",
    "set": "Establecer estrella",
    "cancel": "Cancelar estrella",
    "none": "Nada"
  },
  "pt": {
    "openfile": "Abrir",
    "newfile": "Novo",
    "newfileFromHome": "Criar de Modelo",
    "savefile": "Gravar",
    "saveAs": "Gravar Como",
    "renamefile": "Renomear",
    "encryptfile": "Criptografar",
    "importMenu": "Importar",
    "importData": "Importar Dados",
    "downloadAs": "Exportar",
    "exportData": "Exportar Dados",
    "share": "Partilhar",
    "downloadFile": "Descarregar",
    "print": "Imprimir",
    "pageSet": "Configuração da Página",
    "userLike": "Configuração Padrão",
    "toHome": "Iniciar",
    "set": "Definir estrela",
    "cancel": "Cancelar estrela",
    "none": "nada"
  },
  "it": {
    "openfile": "Apri",
    "newfile": "Nuovo",
    "newfileFromHome": "Crea da Modello",
    "savefile": "Salva",
    "saveAs": "Salva come",
    "renamefile": "Rinomina",
    "encryptfile": "Crittografare",
    "importMenu": "Importa",
    "importData": "Importa Dati",
    "downloadAs": "Esporta",
    "exportData": "Esporta Dati",
    "share": "Condividi",
    "downloadFile": "Scarica",
    "print": "Stampa",
    "pageSet": "Impostazioni Pagina",
    "userLike": "impostazione predefinita",
    "toHome": "Home",
    "set": "Imposta stella",
    "cancel": "Annulla stella",
    "none": "Niente"
  },
  "tw": {
    "openfile": "打開",
    "newfile": "新建",
    "newfileFromHome": "從模板建立",
    "savefile": "儲存",
    "saveAs": "另存新檔",
    "renamefile": "重命名",
    "encryptfile": "檔案加密",
    "importMenu": "導入",
    "importData": "導入數據",
    "downloadAs": "導出",
    "exportData": "導出數據",
    "share": "分享",
    "downloadFile": "下載檔案",
    "print": "列印",
    "pageSet": "默認設置",
    "userLike": "用戶偏好",
    "toHome": "回到首頁",
    "set": "設置",
    "set": "設置星標",
    "cancel": "取消星標"
  }
}
</i18n>
<template>
    <MenuList :menuList="menuList" @handleClicks="handleClicks(...arguments)" @handleMouseenter="handleMouseenter(...arguments)" :showTippy="false">
        <!-- 使用具名插槽 -->
        <template #openfile>
            <label for="chooseLocalFile">
                <div class="menu-item" @click="open">
                    <span class="menu-text">{{ $t("openfile") }}</span>
                    <span class="menu-shortcut">Ctrl+O</span>
                </div>
            </label>
            <input v-if="tempDisable" style="display: none" id="chooseLocalFile" accept=".eddx" type="file" @change="openFile" />
        </template>
    </MenuList>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject, Watch } from "vue-property-decorator";
    import appConfig from "@/public/globalConfig";
    import MenuList from "@/app/components/MenuList.vue";
    declare var egSize: any;

    const KeyMapKey = {
        Import: "importMenu",
        SaveAs: "saveAs",
        Download: "downloadAs",
    };

    @Component({
        components: {
            MenuList,
        },
    })
    export default class FileDrops extends Vue {
        @Inject()
        ["showMessage"];
        @Inject()
        ["checkVipLimit"];

        get showDropdown() {
            return this.$store.state.ui.showDropdown;
        }

        @Watch("showDropdown")
        watchShowDropdown(val) {
            if (!val) {
                this.activeKey = "";
            }
        }

        activeKey = "";

        tempDisable = !appConfig.isBuild;
        objWin: Window;
        saveState: boolean = true;
        // axios: any = axios.create({
        //     baseURL: appConfig.api,
        //     timeout: 50000
        // });
        get otherTypeFile() {
            // 群组文件和分享可编辑文件
            return this.$store.state.ui.isTeamFile || this.$store.state.ui.isShareEditFile;
        }
        get shareOption() {
            return this.$store.state.ui.shareOption;
        }
        get isTeamFile() {
            return this.$store.state.ui.isTeamFile;
        }
        get menuList() {
            let list = [
                { slot: "openfile", isRender: this.tempDisable }, // slot自定义菜单项
                { key: "newfile", isRender: this.tempDisable && !this.isTeamsApp },
                {
                    key: "toHome",
                    isRender: !this.isInclowdz && !this.isWorkwx && !this.isTeamsApp,
                    extraClass: this.activeFunc == "backToHome" && "activeFunc",
                },
                {
                    key: "newfileFromHome",
                    isRender: false,
                    extraClass: this.activeFunc == "fileToHomePage" && "activeFunc",
                },
                {
                    key: "savefile",
                    shortcut: "Ctrl+S",
                    extraClass: this.activeFunc == "fileSaveFile" && "activeFunc",
                },
                {
                    key: "saveAs",
                    isRender: !window.EDCONFIG.IS_SDK,
                    expand: true,
                    active: false,
                    extraClass: this.activeFunc == "fileSaveAs" && "activeFunc",
                },
                { key: "renamefile", extraClass: this.activeFunc == "fileReName" && "activeFunc" },
                {
                    key: "encryptfile",
                    isRender: !this.isTeamFile && window["EDCONFIG"].EMCRYPT_FILE_ENABLE,
                    show: !this.shareUUID,
                    expand: this.isEncrypt,
                    extraClass: this.activeFunc == "fileEncrypt" && "activeFunc",
                },
                { divide: true },
                { key: "importMenu", isRender: this.tempDisable, expand: true, active: false },
                {
                    key: "importData",
                    extraClass: this.activeFunc == "fileImportData" && "activeFunc",
                },
                { divide: true },
                {
                    key: "downloadAs",
                    expand: true,
                    active: false,
                    extraClass: this.activeFunc == "fileOutputData" && "activeFunc",
                },
                { key: "exportData", isRender: this.tempDisable },
                {
                    key: "share",
                    isRender: this.shareOption !== 2 && !this.isTeamFile && !this.isInclowdz && !this.isTeamsApp && !window.EDCONFIG.IS_SDK,
                    show: !this.shareUUID,
                    extraClass: this.activeFunc == "fileShareFile" && "activeFunc",
                },
                {
                    key: "downloadFile",
                    extraClass: this.activeFunc == "fileDownload" && "activeFunc",
                },
                {
                    key: "print",
                    isRender: !this.isInclowdz,
                    shortcut: "Ctrl+P",
                    extraClass: this.activeFunc == "filePrintFile" && "activeFunc",
                },
                // { key: "chart", expand: true },
                { divide: true },
                {
                    key: "pageSet",
                    shortcut: "F6",
                    extraClass: this.activeFunc == "filePageSet" && "activeFunc",
                },
                { key: "userLike", extraClass: this.activeFunc == "fileOptions" && "activeFunc" },
                {
                    key: "star",
                    isRender: !this.otherTypeFile,
                    extraClass: this.activeFunc == "fileStar" && "activeFunc",
                },
            ];
            list.forEach((v) => {
                if ("active" in v) {
                    v.active = this.activeKey === v.key;
                }
            });

            let starLabel = this.fileStar == 1 ? this.$t("cancel") : this.$t("set");
            let resultList = [];
            list.filter((i) => (i.hasOwnProperty("isRender") ? i.isRender : true)).map((item) => {
                resultList.push(
                    item.divide
                        ? item
                        : Object.assign({}, item, {
                              label: item.key == "star" ? starLabel : this.$t(item.key),
                          })
                );
            });
            return { container: "home-drops", list: resultList };
        }
        handleClicks(...args) {
            let key = args[0],
                event = args[1];
            let clickEvents = new Map([
                [
                    "newfile",
                    () => {
                        this.newFiles();
                    },
                ],
                [
                    "toHome",
                    () => {
                        event.stopPropagation();
                        this.toHome();
                    },
                ],
                [
                    "newfileFromHome",
                    () => {
                        this.newfileFromHome();
                    },
                ],
                [
                    "savefile",
                    () => {
                        event.stopPropagation();
                        this.saveFile();
                    },
                ],
                [
                    "renamefile",
                    () => {
                        event.stopPropagation();
                        this.rename();
                    },
                ],
                [
                    "encryptfile",
                    () => {
                        event.stopPropagation();
                        this.encrypt();
                    },
                ],
                [
                    "importData",
                    () => {
                        event.stopPropagation();
                        this.showImportData();
                    },
                ],
                [
                    "exportData",
                    () => {
                        event.stopPropagation();
                    },
                ],
                [
                    "share",
                    () => {
                        event.stopPropagation();
                        this.toShare();
                    },
                ],
                [
                    "downloadFile",
                    () => {
                        event.stopPropagation();
                        this.downloadFile();
                    },
                ],
                [
                    "print",
                    () => {
                        event.stopPropagation();
                        this.print();
                    },
                ],
                [
                    "pageSet",
                    () => {
                        event.stopPropagation();
                        this.changeRightView();
                    },
                ],
                [
                    "userLike",
                    () => {
                        event.stopPropagation();
                        this.showOptions();
                    },
                ],
                [
                    "star",
                    () => {
                        event.stopPropagation();
                        this.setStar();
                    },
                ],
            ]);
            const onClick = clickEvents.get(key);
            onClick && onClick();
        }
        handleMouseenter(...args) {
            let key = args[0],
                event = args[1];
            this.activeKey = KeyMapKey[key];
            this.showExp(event, key);
        }
        open() {
            this.$emit("closeDrop");
        }
        newFiles() {
            this.$emit("closeDrop");
            console.log("debug newFile");
            let url = "http://localhost:8080/app.html?action=openfile";
            window.open(url);
        }
        newfileFromHome() {
            this.$track("menu", "file", "new file from home");
            this.$emit("closeDrop");
            window["_view"]._tool.endEdit();
            if (this.objWin == null || this.objWin.closed) this.objWin = window.open(`${window.location.origin}/online`, "maxHome");
            else {
                window.open("", "maxHome");
            }
        }
        saveFile() {
            this.$track("menu", "file", "save file");
            this.$root["ui"].toSaving(true, false, true, "button");
            this.$emit("closeDrop");
        }
        rename() {
            console.log("rename Dialog ...");
            this.$track("menu", "file", "rename");
            let dom = <HTMLElement>document.querySelector(".edit-span");
            let clickEvent = document.createEvent("MouseEvents");
            clickEvent.initEvent("click", true, true);
            dom.dispatchEvent(clickEvent);
            this.$emit("closeDrop");
        }
        get isEncrypt() {
            return this.$store.state.ui.isEncrypt;
        }

        encrypt() {
            if (this.isEncrypt) return;
            this.$store.commit("setStatus", {
                type: "showCryptModal",
                data: true,
            });
            this.$store.commit("setStatus", {
                type: "cryptType",
                data: "encry",
            });
            this.$emit("closeDrop");
        }

        openFile(item) {
            if (!item.target.files.length) {
                return;
            }
            // this.$store.commit('setStatus',{
            //     type: 'showLibrary',
            //     data: true
            // });
            let oFReader = new FileReader();
            var zip;
            var oFile = item.target.files[0];
            document.title = oFile.name + " - MaxOnline";
            window["_view"].setDocName(oFile.name.match(/[^\/]*(?=\.eddx)/)[0]);
            oFReader.readAsArrayBuffer(oFile);
            oFReader.onload = function (oFREvent: any) {
                zip = oFREvent.target.result;
                window["_view"].openFromFile(zip);
            };
            this.$emit("closeDrop");
            window.history.pushState({}, "0", window.location.origin + window.location.pathname);
        }
        showExpand() {
            this.$store.commit("setStatus", {
                type: "showDropExpand",
                data: true,
            });
        }

        showExp(e: MouseEvent, type: string) {
            if (type == "Crypt" && !this.isEncrypt) return;
            let node = <HTMLElement>e.target;
            let scrollTop = node.parentElement.scrollTop;
            let ts: any = this;
            ts.$bus.$emit("changeDropType", type, node.offsetTop - scrollTop);
            if (["SaveAs", "Crypt", "Import", "Download"].includes(type)) {
                this.showExpand();
            }
        }
        showImportData() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "ImportData",
            });
            this.$emit("closeDrop");
        }

        downloadFile() {
            this.$emit("closeDrop");
            if (
                !this.$checkAuth({
                    type: "downloadFiles",
                    buyTrigger: "others",
                    pcParams: { newUpgrade: 0, upgrade: 0 },
                })
            )
                return;
            if (this.checkVipLimit("downloadFile")) {
                return;
            }
            if (this.isInclowdz) {
                this.inclowdzDownload();
                return;
            }
            window["_view"].saveFileToLocal();
        }
        inclowdzDownload() {
            let ts: any = this;
            let obj = ts.$unZipFileName(window.location.search.substr(1)).substr(4);
            let filePath = obj.match(/[^\/]+\/[^\/]+\/(.+)/) && obj.match(/[^\/]+\/[^\/]+\/(.+)/)[1];
            let params = Object.assign(
                { obj: filePath },
                {
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                }
            );
            this.$edApi.getDownFileAddress(params).then((res) => {
                let downUrl = `${window["GLOBAL"].PRIVATE_OSS_HOST}${encodeURIComponent(obj)}?${res.data.sign}`;
                let ossParams = {
                    url: obj,
                    exp: res.data.exp,
                    sign: res.data.sign || res.data.query,
                    responseType: "blob",
                };
                this.$edApi.downloadOSSFile(ossParams).then((e) => {
                    window.parent.postMessage(
                        {
                            mode: "iframe2parent",
                            target: "file",
                            action: "export",
                            type: "request",
                            session_id: "0000000003",
                            version: "v1",
                            data: {
                                filename: obj.match(/[^\/]*(?=\.eddx)/i)[0] + ".eddx",
                                filesize: e.data.size,
                                download_url: downUrl,
                            },
                        },
                        "*"
                    );
                });
            });
        }
        changeRightView() {
            this.$track("menu", "file", "show page set");
            this.$emit("closeDrop");
            let ts: any = this;
            ts.$bus.$emit("changeRightViewActiveKey", "pageset");
            ts.$bus.$emit("changeRightView", "pageset", false, "other");
        }
        showOptions() {
            this.$track("menu", "file", "show options");
            this.$emit("closeDrop");
            if (!this.userInfo) {
                let ts: any = this;
                ts.$bus.$emit("login");
                ts.$emit("closeDrop");
                return;
            }
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "Options",
            });
        }

        print() {
            this.$track("menu", "file", "show print");
            this.sensors.track("printButton", {
                Catalogues: "Print",
            });
            this.$emit("closeDrop");
            window["_view"]._tool.endEdit();
            this.$store.commit("setStatus", {
                type: "showPrintContainer",
                data: true,
            });
        }

        toShare() {
            let ts: any = this;
            ts.$bus.$emit("shareFile");
            this.$emit("closeDrop");
        }

        toHome() {
            this.$emit("closeDrop");
            this.$track("menu", "file", "toHome");
            let ts: any = this;
            ts.$bus.$emit("toHome");
        }

        setStar() {
            let type = this.fileStar ^ 1;
            if (window.EDCONFIG.IS_SDK) {
                this.sdkApp.promisePostMessage("POST_COLLECT", { type }).then(() => {
                    this.fileStar = type;
                    this.$emit("closeDrop");
                });
                return;
            }

            let params = {
                id: this.userInfo.user_id,
                token: this.userInfo.token,
                start_tag: type,
                obj_id: this.fileID,
            };
            if (this.isPrivate) {
                Object.assign(params, {
                    file_key: this.$store.getters.fileKey,
                });
            }
            this.$edApi.setStar(params).then((res) => {
                let getPath = () => {
                    let ts: any = this;
                    let filePath = ts.$unZipFileName(window.location.search.substr(1)).substring(4);
                    let path = "",
                        pathArr = filePath.split("/");
                    pathArr.shift();
                    pathArr.shift();
                    pathArr.pop();
                    if (pathArr.length > 0) {
                        path = pathArr.join("/") + "/";
                    }
                    return path;
                };
                window.opener &&
                    window.opener.postMessage(
                        {
                            type: "updateMyfile",
                            updateStarFile: true,
                        },
                        location.origin
                    );
                window.opener &&
                    window.opener.postMessage(
                        {
                            type: "updateCloudFileStar",
                            fileID: this.fileID,
                            path: getPath(),
                            status: type,
                        },
                        location.origin
                    );
                this.fileStar = type;
            });
            this.$emit("closeDrop");
        }

        get fileStar() {
            return this.$store.state.ui.fileStar;
        }
        set fileStar(v) {
            this.$store.commit("setStatus", {
                type: "fileStar",
                data: v,
            });
        }
        get fileID() {
            return this.$store.state.ui.fileID;
        }
        get userInfo() {
            return this.$store.state.user.userInfo;
        }
        get activeFunc() {
            return this.$store.state.ui.activeFunc;
        }
        get shareUUID() {
            return this.$store.state.ui.shareUUID;
        }
        mounted() {}

        created() {}

        deactivated() {
            this.activeKey = "";
        }
    }
</script>
